import { useTranslation } from 'react-i18next';
import LinearLoader from '../../../yoello-lib/modules/components/UI/Loaders/LinearLoader';

const Loader = () => {

    const { t } = useTranslation();

    return (
        <div>
            <h3>{t("signup.merchantCreate.loading")}</h3>
            <LinearLoader title={""} />
        </div>
    )
}

export default Loader;